export function triggerBrowserDownload(blob: Blob, filename = 'file.pdf') {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}

export function getFilenameFromContentDisposition(
  header?: string
): string | undefined {
  if (!header) return
  // content-disposition: attachment; filename="invoice.pdf"
  const match = /filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i.exec(header)
  return match?.[1]
}
